/* eslint-disable no-underscore-dangle */
import CartVisibilityHandler from '../../cart-popup/visibility-handler';
import CartApi from '../../api/cart';
import { addLoadingState, removeLoadingState } from '../loading-state-helpers';
import analytics from '../../analytics';

export default class AddToCartHandler {
  constructor(selector, containers) {
    this.selector = selector;
    this.containers = containers;
  }

  cartApi = new CartApi();

  handleAddToCart = ({ target }) => {
    const params = this.buildRequestParams(target);

    addLoadingState(target);

    this.cartApi.getCartData()
      .then(({ data }) => {
        const existingLineItem = data.items.find((item) => (
          String(item.variant_id) === String(params.variantId)
          && params.isSubscription === Boolean(item.properties?._subscription_id)
        ));

        if (existingLineItem) {
          this.updateVariantData({
            target,
            params,
            existingLineItem
          });

          return;
        }

        this.addVariant({
          target,
          params
        });
      });
  };

  updateVariantData = ({
    target,
    params,
    existingLineItem
  }) => {
    const {
      key: id,
      variant_id: variantId,
      quantity
    } = existingLineItem;

    this.cartApi
      .changeCartItem({
        id,
        variantId,
        quantity: quantity + params.quantity,
        isSubscription: params.isSubscription
      })
      .then(this.onAddVariant({
        quantity: params.quantity,
        target
      }))
      .catch((error) => {
        console.log(error); // eslint-disable-line no-console
      });
  };

  addVariant = ({
    target,
    params
  }) => {
    this.cartApi
      .addCartItem(params)
      .then(this.onAddVariant({
        quantity: params.quantity,
        target
      }))
      .catch((error) => {
        console.log(error); // eslint-disable-line no-console

        removeLoadingState(target);
      });
  };

  onAddVariant = ({
    target,
    quantity
  }) => ({ data }) => {
    (new CartVisibilityHandler()).showMenu();
    removeLoadingState(target);
    if (data.items) {
      data.items.forEach((item) => analytics.productAdded({
        data: item,
        quantity
      }));
    } else {
      analytics.productAdded({
        data,
        quantity
      });
    }
  };

  buildRequestParams = ({
    dataset: {
      variantId,
      localSubscriptionState
    }
  }) => ({
    variantId,
    quantity: this.selector.getQuantity(),
    isSubscription: this.selector.isSubscription(localSubscriptionState)
  });

  initializeEventListeners = () => {
    this.containers.forEach((container) => {
      const buttons = container.getElementsByClassName('js-add-to-cart-button');

      [...buttons].forEach((button) => {
        if (!button._hasEventListener) {
          button.addEventListener('click', this.handleAddToCart);
          button._hasEventListener = true;
        }
      });
    });
  };
}
